import { Box, IconButton, Menu, MenuItem } from "@mui/material";
import Badge from "@mui/material/Badge";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import AddCircle from "@mui/icons-material/AddCircle";
import FaceIcon from "@mui/icons-material/Face";
import { Auth } from "aws-amplify";
import React from "react";
import { ROUTES } from "../Routes";
import { headerTheme, mainTheme } from "./themes";

export default function DesktopMenu(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const isLoggedOn = props.isLoggedOn;

  if (isLoggedOn === false) {
    return null;
  }
  const id = props.id;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Box display={{ xs: "none", sm: "none", md: "block" }}>
        <Button
          style={{ color: headerTheme.palette.text.secondary }}
          href="#availablejobs"
        >
          Annonser
        </Button>

        <Button
          style={{ color: headerTheme.palette.text.secondary }}
          href="#myjobrequests"
        >
          Min Sida
        </Button>

        <Chip
          icon={<AddCircle />}
          color="secondary"
          style={{ marginLeft: "1vh" }}
          label="LÄGG IN ANNONS"
          onClick={() => {
            window.location = ROUTES.MY_JOB_REQUESTS + "?createNewAd";
          }}
          clickable
        />

        <IconButton
          edge="end"
          style={{ marginRight: "-30px" }}
          color="inherit"
          aria-label="menu"
          onClick={handleClick}
        >
          <Badge
            color="error"
            variant="dot"
            fontSize="large"
            overlap="circular"
            invisible={id ? true : false}
          >
            <FaceIcon fontSize="large" />
          </Badge>
        </IconButton>

        <Menu
          disablePortal={true}
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          style={{ marginTop: "30px" }}
        >
          <MenuItem
            style={{ color: mainTheme.palette.text.primary }}
            onClick={() => {
              handleClose();
              window.location = "#myprofile";
            }}
          >
            Mitt Konto
          </MenuItem>
          {/** <MenuItem
            style={{ color: mainTheme.palette.text.primary }}
            onClick={() => {
              handleClose();
              window.location = "#about";
            }}
          >
            Om Oss
          </MenuItem> */}
          <MenuItem
            style={{ color: mainTheme.palette.text.primary }}
            onClick={() => {
              handleClose();
              Auth.signOut();
            }}
          >
            Logga Ut
          </MenuItem>{" "}
        </Menu>
      </Box>
    </>
  );
}
